import { render, staticRenderFns } from "./AgentHome.vue?vue&type=template&id=31bb051b&scoped=true"
import script from "./AgentHome.vue?vue&type=script&lang=js"
export * from "./AgentHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31bb051b",
  null
  
)

export default component.exports